import { decode } from 'html-entities'
import React from 'react'
import { useTranslation } from 'react-i18next'
import styles from './styles.module.scss'

const WorkplaceGroupCard = ({ g, i, id, handleClick, getGroupRoleColor }) => {
  const { t } = useTranslation()

  return (
    <React.Fragment key={i}>
      <a
        role='button'
        tabIndex='0'
        id={id}
        className={`${styles.cardItem} ${styles['defaultImage']}`}
        style={
          g?.group_cover
            ? {
                backgroundImage: `url(${g?.group_cover})`
              }
            : null
        }
        onClick={() => {
          if (handleClick) {
            handleClick(g)
          }
        }}>
        <div className={styles.overlay} />
        <div className={`${styles.role} ${styles[getGroupRoleColor(g?.role)]}`}>
          {t(`components.avatar.${g?.role}`)}
        </div>
        <div className={styles.title}>{decode(g?.group_name)}</div>
        <div className={styles.general}>
          <div className={`${styles.workplaceName} ${styles[g?.workplace.color]}`}>{g?.workplace.acronym}</div>
          <div className={styles.membersText}>
            {g?.member_count > 1
              ? t('workplaceSettings.groups.members', { count: g?.member_count })
              : t('workplaceSettings.groups.member', { count: g?.member_count })}
          </div>
          <div className={`${styles.backgroundImage} ${styles[g?.workplace.color]}`} />
        </div>
      </a>
    </React.Fragment>
  )
}

export default WorkplaceGroupCard
